module.exports = __webpack_public_path__ + "img/hourglass-01.7166f7f5.svg";